export const validLatitude = latitude => {
  return isFinite(latitude) && Math.abs(latitude) <= 90
}

export const validLongitude = longitude => {
  return isFinite(longitude) && Math.abs(longitude) <= 180
}
